import React, { useState, useCallback, useMemo, Suspense } from "react";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";

// Lazy-loaded components
const AttendanceSetup = React.lazy(() => import("./AttendanceSetup"));
const ActivityAttendance = React.lazy(() => import("./ActivityAttendance"));
const MarkAttendance = React.lazy(() => import("./MarkAttendance"));
const AcademicCalendar = React.lazy(() => import("./AcademicCalendar"));
const LeaveType = React.lazy(() => import("./LeaveType"));
const CopyAttendancePlan = React.lazy(() => import("./CopyAttandencePlan"));

const AttendanceSetupForm = React.memo(() => {
  const [activeTab, setActiveTab] = useState("LeaveType");
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  // Memoize the tab change handler
  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  // Memoize tab content
  const tabContent = useMemo(() => {
    switch (activeTab) {
      case "AttendanceSetup":
        return <AttendanceSetup />;
      case "ActivityAttendance":
        return <ActivityAttendance />;
      case "AcademicCalendar":
        return <AcademicCalendar />;
      case "LeaveType":
        return <LeaveType />;
      case "CopyAttendancePlan":
        return <CopyAttendancePlan />;
      default:
        return <div className="p-3">Select a tab to view content</div>;
    }
  }, [activeTab]);

  return (
    <div className="">
      <div className="page-header d-flex mb-2 align-items-center justify-content-between">
        <h2 className="page-heading fs-7">Attendance Management</h2>
      </div>
      {/* Bootstrap Nav Tabs */}
      <ul
        className="nav nav-tabs setup-tabs mb-3 gap-1"
        id="workflowTabs"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === "LeaveType" ? "active" : ""}`}
            id="leaveType-tab"
            type="button"
            role="tab"
            aria-controls="leaveType"
            aria-selected={activeTab === "LeaveType"}
            onClick={() => handleTabChange("LeaveType")}
          >
            Leave Type
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${
              activeTab === "AcademicCalendar" ? "active" : ""
            }`}
            id="academicCalendar-tab"
            type="button"
            role="tab"
            aria-controls="academicCalendar"
            aria-selected={activeTab === "AcademicCalendar"}
            onClick={() => handleTabChange("AcademicCalendar")}
          >
            Academic Calendar
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${
              activeTab === "AttendanceSetup" ? "active" : ""
            }`}
            id="attendanceSetup-tab"
            type="button"
            role="tab"
            aria-controls="attendanceSetup"
            aria-selected={activeTab === "AttendanceSetup"}
            onClick={() => handleTabChange("AttendanceSetup")}
          >
            Attendance Setup
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${
              activeTab === "CopyAttendancePlan" ? "active" : ""
            }`}
            id="copyAttendancePlan-tab"
            type="button"
            role="tab"
            aria-controls="copyAttendancePlan"
            aria-selected={activeTab === "CopyAttendancePlan"}
            onClick={() => handleTabChange("CopyAttendancePlan")}
          >
            Copy Attendance Plan
          </button>
        </li>
      </ul>

      {/* Tab Content with Suspense */}
      <div className="tab-content" id="workflowTabContent">
        <Suspense fallback={<div className="p-3 text-center">Loading...</div>}>
          <div
            className="tab-pane fade show active"
            id="activeTabContent"
            role="tabpanel"
          >
            {tabContent}
          </div>
        </Suspense>
      </div>
    </div>
  );
});

export default AttendanceSetupForm;
